<template>
  <div style="background-color: #edf4fc;height: 100%;">
    <div style="height: 0.5rem;width: 100%;">
      <div style="margin-right: 0.1rem;float: right;width: 100%;">
        <a href="javascript:void(0)" @click="manager('/')" style="float: left;">
          <img src="@/assets/logo.gif" alt="联考之家" class="menu-img-size" />
        </a>
        <div class="header-home">
          <a href="javascript:void(0)" @click="manager('/login')" class="header-home-a">进入登录页</a>
        </div>
        <div class="header-home">
          <a href="javascript:void(0)" @click="manager('/')" class="header-home-a">回到首页</a>
        </div>
      </div>
    </div>
    <div class="register-form">
      <div class="register-form-div1">注册</div>
      <div class="register-form-div2">请填写基本信息</div>
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item prop="userName" label="用户名">
          <el-input v-model="form.userName" placeholder="用户名" autofocus="true"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input v-model="form.password" placeholder="密码" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item prop="phonenumber" label="手机号">
          <el-input v-model="form.phonenumber" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="form.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickName" placeholder="昵称"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form.sex">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker type="date" placeholder="选择生日" v-model="form.birthday" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked">
            <span style="font-size: 0.13rem;">我已阅读并同意</span>
            <a href="javascript:void(0)" @click="managerBlank('/protocol')" style="color: blue;font-size: 0.13rem;">《用户协议》</a>、
            <a href="javascript:void(0)" @click="managerBlank('/policy')" style="color: blue;font-size: 0.13rem;">《隐私政策》</a>
          </el-checkbox>
          <el-button type="primary" @click="register" class="register-form-button" :disabled="!checked">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { registerAPI } from '@/api/user'

export default {
  // name 是当前组件的名称（建议为每个组件都指定唯一的 name 名称）
  name: 'Register',
  data () {
    return {
      checked: false,
      // 登录表单的数据，最终要双向绑定到 form 这个数据对象上
      form: {
        // 用户名
        userName: '',
        // 昵称
        nickName: '',
        // 登录的密码
        password: '',
        // 邮箱
        email: '',
        // 手机号
        phonenumber: '',
        // 用户性别
        sex: 0,
        // 生日
        birthday: ''
      },
      // 表单的校验规则对象
      rules: {
        // 用户名的校验规则
        userName: [{ required: true, message: '请填写您的用户名', trigger: 'blur' }],
        // 昵称的校验规则
        nickName: [{ required: true, message: '请填写您的昵称', trigger: 'blur' }],
        // 密码的校验规则
        password: [{ required: true, message: '请填写您的密码', trigger: 'blur' }],
        // 邮箱的校验规则
        email: [{ required: true, message: '请填写您的邮箱', trigger: 'blur' }],
        // 手机号的校验规则
        // 只有同时满足以下两个验证规则，才能验证通过
        phonenumber: [
          // 必填项的校验规则
          { required: true, message: '请填写您的手机号', trigger: 'blur' },
          // 11 位手机号的校验规则
          { pattern: /^1\d{10}$/, message: '请填写正确的手机号', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        // 生日的校验规则
        birthday: [{ required: true, message: '请填写您的生日', trigger: 'blur' }]
      }
    }
  },
  methods: {

    async register () {
      if (this.form.userName !== '' && this.form.password !== '' && this.form.phonenumber !== '' && this.form.email !== '') {
        const { data: res } = await registerAPI(this.form)
        // 判断是否登录成功了
        if (res.code === 200) {
          // 注册成功后，跳转到登录页
          this.$router.push('/login')
        } else {
          this.$message({
            message: '此用户名已经使用，请修改',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '用户名、手机号、邮箱或密码不能为空',
          type: 'warning'
        })
      }
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    },
    manager (address) {
      this.$router.push({ path: address })
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none !important;
}
a:hover {
  color: red !important;
}
.menu-img-size {
  width: 1rem;
  height: 0.5rem;
}
.header-home {
  float: right;
  margin-right: 0.1rem !important;
  height: 0.5rem;
  font-size: 0.13rem;
  padding-right: 0.2rem;
}
.header-home-a {
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  vertical-align: middle;
  text-align: center;
}
.register-form {
  right: 1rem;
  width: 5rem;
  margin: 0 auto;
  padding-top: 0.2rem;
  margin-left: 2rem;
  padding-bottom: 0.2rem;
}
.register-form-div1 {
  display: inline-block;
  height: 0.4rem;
  width: 5rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.3rem;
  margin-bottom: 0.1rem;
}
.register-form-div2 {
  display: inline-block;
  height: 0.2rem;
  width: 5rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.13rem;
  color:gray;
  margin-bottom: 0.2rem;
}
.register-form-button {
  width: 100%;
  margin: 0 auto;
  font-size: 0.13rem;
}
/deep/ .el-form-item {
  margin-bottom: 0.2rem;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
/deep/ .el-form-item__label {
  font-size: 0.13rem;
}
/deep/ .el-radio__inner {
  font-size: 0.13rem;
}
/deep/ .el-radio {
  font-size: 0.13rem;
}
/deep/ .el-radio__label {
  font-size: 0.13rem;
}
</style>
